import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import {
    setError,
    setEmailError,
    setFormValues,
    setIsPatchEditEmployeeSuccess,
    setSelectedEmployee,
} from "../EditEmployeeModalSlice";

interface HandleResendChangeEmailProps {
    selectedEmployee: EmployeeInterface;
    dispatch: Dispatch;
    resendChangeEmail: (params: { id: number }) => {
        unwrap: () => Promise<unknown>;
    };
    refetchEmployeeMe: () => Promise<unknown>;
}

export const handleResendChangeEmail = async (
    props: HandleResendChangeEmailProps,
): Promise<void> => {
    const { selectedEmployee, dispatch, resendChangeEmail, refetchEmployeeMe } =
        props;

    if (!selectedEmployee) {
        return;
    }

    try {
        await resendChangeEmail({
            id: selectedEmployee.id,
        }).unwrap();

        toast.info("Verificatie e-mail is opnieuw verstuurd");

        // Wait for the refetch to complete before updating the state
        await refetchEmployeeMe();

        dispatch(setSelectedEmployee(selectedEmployee));
        dispatch(setFormValues(null));
        dispatch(setIsPatchEditEmployeeSuccess(true));
        dispatch(setError(null)); // Clear any existing general error messages
        dispatch(setEmailError(null)); // Clear any existing email-specific error messages
    } catch (err) {
        const errorData = err as ErrorInterface;
        // Add null check to prevent "Cannot read properties of undefined (reading 'message')" error
        const errorMessage =
            errorData?.data?.message ||
            "Er is een fout opgetreden bij het opnieuw versturen van de verificatie e-mail";
        dispatch(setError(errorMessage));
    }
};
